import DashboardLegalAssistantChart from './DashboardLegalAssistantChart';

export default DashboardLegalAssistantChart;
